const StructureTypeMainBlotterCellRenderer = (params: any) => {
  if (!params.data) {
    return null;
  }

  const valueFormatted = params.valueFormatted || "";
  const validPrefixes = ["NPV", "Recoupon", "Unwind"];

  // Check if starts with a valid prefix followed by " - "
  const hasValidPrefix = validPrefixes.some((prefix) =>
    valueFormatted.startsWith(`${prefix} - `),
  );

  if (hasValidPrefix) {
    // Split only on the first " - " (with spaces)
    const separatorIndex = valueFormatted.indexOf(" - ");
    const prefix = valueFormatted.substring(0, separatorIndex);
    const structureType = valueFormatted.substring(separatorIndex + 3); // +3 to skip " - "

    return (
      <div data-testid="structureTypeCellContainer">
        <span data-testid="structureTypePrefix" className="font-bold">
          {prefix}
        </span>
        <span data-testid="structureTypeSeparator"> - </span>
        <span data-testid="structureTypeValue">{structureType}</span>
      </div>
    );
  }

  // No valid prefix, just display the value as-is
  return <div data-testid="structureTypeCellContainer">{valueFormatted}</div>;
};
export default StructureTypeMainBlotterCellRenderer;
